exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".currencyText[data-v-f7de4e5c],.display-tooltip[data-v-f7de4e5c]{display:-webkit-box;display:-ms-flexbox;display:flex}.currencyText[data-v-f7de4e5c]{position:relative}.currencyText input[data-v-f7de4e5c]{padding-left:23px}.currencyText[data-v-f7de4e5c]:before{position:absolute;content:\"$\";left:7px;top:9px;font-size:19px}.subsection-bold[data-v-f7de4e5c]{color:#000}.disabled-subsection[data-v-f7de4e5c]{color:#a3a3a3}", ""]);

// exports
